import { render, staticRenderFns } from "./Avzyz.vue?vue&type=template&id=2592a6ae&scoped=true&"
import script from "./Avzyz.vue?vue&type=script&lang=js&"
export * from "./Avzyz.vue?vue&type=script&lang=js&"
import style0 from "./Avzyz.vue?vue&type=style&index=0&id=2592a6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592a6ae",
  null
  
)

export default component.exports